/**
 * Invoice route IDs preserve whitespace and reserved characters verbatim.
 * Contract matches backend InvoiceIdSchema: 1..512 UTF-16 units, valid
 * Unicode, no NUL, and not a literal dot segment (WHATWG normalizes those).
 */
export function encodeInvoiceId(id: string): string {
  if (
    !id ||
    id.length > 512 ||
    id.includes('\0') ||
    id === '.' ||
    id === '..'
  ) {
    throw new Error('Invalid Invoice ID')
  }
  return encodeURIComponent(id)
}
